import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Button from '#components/a/Button'
import InputNumber from '#components/a/form/InputNumber'

function SelectNachweis(props) {
  return (
    <form className="selectNachweis" onSubmit={props.onButtonClick}>
      <InputNumber
        type="number"
        value={props.inputValue}
        autoFocus={props.autoFocus}
        onChangeHandle={props.onInputChange}
        placeholder={i18n.t('select_nachweis_placeholder')}
      />
      <Button
        text={i18n.t('misc_add')}
        variant="primarydark"
        event={props.onButtonClick}
        disabled={props.buttonIsDisabled}
      />
    </form>
  )
}

SelectNachweis.propTypes = {
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func,
  onButtonClick: PropTypes.func,
  buttonIsDisabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
}

export default SelectNachweis
